import { useState } from "react";
import axios from "../../libs/axiosConfig";

const usePrivacy = () => {
    const [privacy, setPrivacy] = useState({ status: "STANDBY", data: null, errorCode: "" });
    const getHeader = (moreOptions) => {
        let headers = {
            Authorization: `Bearer ${localStorage.getItem("actk") ?? ""}`
        };
        if (moreOptions) headers = { ...headers, ...moreOptions };

        return headers;
    };

    const getPrivacyConsent = async () => {
        await axios
            .get(`${process.env.REACT_APP_API_CRM}/api/privacies/check-accept`, { headers: getHeader() })
            .then((res) => {
                setPrivacy({
                    status: "GET_SUCCESS",
                    data: res.data,
                    errorCode: "",
                });
            })
            .catch((err) => {
                if (window.location.pathname !== "/privacy") {
                    window.location.href = "/privacy"
                }
                setPrivacy({
                    status: "GET_ERROR",
                    data: err.response ? err.response.data : null,
                    errorCode: err.response ? err.response.status : "",
                });
            });
    };

    const consentPrivacy = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_CRM}/api/privacies/accept`, null, { headers: getHeader() })
            .then((res) => {
                setPrivacy({
                    status: "CONSENT_SUCCESS",
                    data: res.data,
                    errorCode: "",
                });
            })
            .catch((err) => {
                setPrivacy({
                    status: "CONSENT_ERROR",
                    data: err.response ? err.response.data : null,
                    errorCode: err.response ? err.response.status : "",
                });
            });
    };

    return { privacy, setPrivacy, getPrivacyConsent, consentPrivacy };
};

export default usePrivacy;